import BaseExecutor from 'services/sports/default/base-executor';
import {RandomTeamStackingValidatorBuilder} from 'services/sports/lol/validator/random-team-stacking-validator-builder';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';

export default class UserAdjustmentsValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {randomTeamStacking: stacking, userPointsType} = Action.getState();

        if (stacking.isEnabled()) {
            return new RandomTeamStackingValidatorBuilder().getInterface();
        }

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (!this._isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        return validator;
    }

    _isAnyStackingUsed() {
        return this._isPlayerCombinationStackingUsed();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }
}
